import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex gap-x-2" }

import { inject, Ref, ref } from 'vue';
import { Sockets } from '@/typings/sockets';
import { PromptModal } from '@/typings/modal';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const promptModal = inject('promptModal') as Ref<PromptModal>;

const $socket: Sockets = inject('$socket') as Sockets;
const version = ref(process.env.VUE_APP_VERSION);
const currentVersion = process.env.VUE_APP_VERSION;
$socket.on('build_version', async (newVersion: string) => {
  if (newVersion !== version.value) {
    const oldVersion = version.value.toString();
    version.value = newVersion;

    const doRefresh = await promptModal.value.show(
      `A new version is available`,
      `You are on v${oldVersion}. We have detected that v${newVersion} is available. Do you want to update now, any unsaved changes will be lost? You can always update later by refreshing your page.`
    );

    if (doRefresh) {
      reload();
    }
  }
});

function reload() {
  window.location.reload();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, "v" + _toDisplayString(_unref(currentVersion)), 1),
    (_unref(currentVersion) !== version.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "#",
          onClick: reload,
          class: "hover:text-primary"
        }, " Update Now! "))
      : _createCommentVNode("", true)
  ]))
}
}

})